import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { APPINSIGHTS_STRINGS } from "../constants/appInsightsStrings";
import { trackEvent } from "../utils/appInsights";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress } from "@mui/material";

import { uploadSelectedFile, createSegments } from "../network/cipAPI";
// import XLSFileDownload from "../XLSDownload";

import { cleanData } from "../Store/TemplateStore/template.action";

import createNotification, {
  SUCCESS_NOTIFICATION,
} from "../components/Notifications";
import DupontButton from "../components/DupontButton";

import { ValueStrings } from "../utils/constantsString";
import PopoverText from "../../src/components/PopoverText";
import InfoIconGreen from "../../src/assets/info-icon-green.svg";
import QuestionIcon from "../../src/assets/question-icon.svg";

const PerformanceData = React.forwardRef(
  (
    {
      setFileId,
      fileId,
      setColumnsOptions,
      setSegmentsOptions,
      fileInfo,
      setDatasetDetails,
      plantName,
      water_type,
      setMinDate,
      setMaxDate,
      setView,
      setAddCecButtonDisable,
    },
    ref
  ) => {
    const { t } = useTranslation();

    const performanceData = async () => {
      if (!fileId) {
        setError(t("ValueStrings.validFile"));
        return;
      }
    };

    React.useImperativeHandle(ref, () => ({ performanceData }));
    const [file, setFile] = useState(null);
    const inputRef = useRef(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isFileLoading, setIsFileLoading] = useState(false);
    const [fileName, setFileName] = useState(fileInfo?.fileName);
    const userName = useSelector((state) => state.userName);

    const dispatch = useDispatch();

    useEffect(() => {
      setFileName(fileInfo.fileName);
    }, [fileInfo]);

    const getFormattedDate = (dateString) => {
      const date = moment(dateString).isValid();
      return date ? moment(dateString).format(ValueStrings.dateFormat) : "";
    };

    const uploadFile = async (file) => {
      setIsLoading(true);
      try {
        if (!isLoading) {
          const chunkSize = 3 * 1024 * 1024; // 3MB per chunk
          const totalChunks = Math.ceil(file.size / chunkSize);
          const fileName = file.name;

          var promise_list = [];
          for (let i = 0; i < totalChunks; i++) {
            const chunk = file.slice(i * chunkSize, (i + 1) * chunkSize);
            const formData = new FormData();
            formData.append("File", chunk, fileName);
            promise_list.push(
              uploadSelectedFile(formData, encodeURIComponent(fileName), i + 1, totalChunks, false)
            );
            // const response = axios.post('http://127.0.0.1:5001/api/v1/plants/159/uploadfile?chunkIndex='+(i+1)+'&totalChunks='+totalChunks, formData, {
            //    headers: {'Content-Type': 'multipart/form-data','sso_email_id':'sovit.mittal@dupont.com'}
            //  });
            //  promise_list.push(response);
          }
          await Promise.all(promise_list);
          // for the last chunk
          const chunk = file.slice(
            (totalChunks - 1) * chunkSize,
            totalChunks * chunkSize
          );
          const formData = new FormData();
          formData.append("File", chunk, fileName);
          // const response1 =await axios.post('http://127.0.0.1:5001/api/v1/plants/159/uploadfile?chunkIndex='+totalChunks+'&totalChunks='+totalChunks, formData, {
          //   headers: {'Content-Type': 'multipart/form-data','sso_email_id':'sovit.mittal@dupont.com'}
          // });
          // const response = response1.data;

          // const LastApiCallResponse = await uploadSelectedFile(
          //   formData,
          //   encodeURIComponent(fileName),
          //   totalChunks,
          //   totalChunks,
          //   false
          // );
          const response = await uploadSelectedFile(
            null,
            encodeURIComponent(fileName),
            totalChunks,
            totalChunks,
            true
          );

          if (response && response.file_id === 0) {
          } else if (response && response.file_id !== 0) {
            setIsFileLoading(false);
            setColumnsOptions(response?.cols);
            setFileId(response.file_id);
            const segmentresposnse = await createSegments();
            if (segmentresposnse) {
              setAddCecButtonDisable(false);
            }
            const segments = segmentresposnse.segments;
            if (Array.isArray(segments) && segments.length > 0) {
              const segmentarray = [];
              segments.forEach((segment) => {
                segmentarray.push(
                  `${segment.start_date} - ${segment.end_date}`
                );
              });
              setSegmentsOptions(segmentarray);
            }
            setView(2);
            setMinDate(segmentresposnse.min_date);
            setMaxDate(segmentresposnse.max_date);
            
            const datasetName = ` ${userName}_ ${plantName}_ ${water_type}
              ${getFormattedDate(segmentresposnse.min_date)
                ? `_ ${getFormattedDate(segmentresposnse.min_date)}`
                : ""
              }
              ${getFormattedDate(segmentresposnse.max_date)
                ? `to ${getFormattedDate(segmentresposnse.max_date)}`
                : ""
              }`;
            
            setDatasetDetails(datasetName);

            // Track successful file upload
            trackEvent(APPINSIGHTS_STRINGS.FILE_UPLOADED, {
              fileName: file.name,
              fileSize: file.size,
              userEmail: userName,
              plantName: plantName,
              waterType: water_type,
              datasetName: datasetName.trim(),
              startDate: getFormattedDate(segmentresposnse.min_date),
              endDate: getFormattedDate(segmentresposnse.max_date)
            });

            createNotification(
              SUCCESS_NOTIFICATION,
              t("notificationStrings.fileSuccess"),
              ""
            );
            dispatch({
              type: "STORE_FILE_ID",
              payload: {
                file_id: response?.file_id,
                fileName: file.name,
              },
            });
          } else {
            setError(response?.detail.error);
          }
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
        setIsFileLoading(false);
      }
    };

    const handleFileUpload = (e) => {
      setError(null);
      const uploadedFile = e.target.files[0];
      if (uploadedFile) {
        setIsFileLoading(true);
        const reader = new FileReader();
        reader.onload = (e) => {
          setFile(uploadedFile);
          uploadFile(uploadedFile);
        };
        reader.readAsBinaryString(uploadedFile);
      }
    };

    const handleAddFileClick = () => {
      if (inputRef.current) {
        inputRef.current.click();
      }
    };

    const handleCloseClick = () => {
      inputRef.current.value = "";
      dispatch(cleanData());
      setFile(null);
      setError(null);
      setFileId(null);
      setFileName(null);
      setAddCecButtonDisable(true);
      dispatch({
        type: "STORE_FILE_ID",
        payload: {
          file_id: null,
          fileName: null,
        },
      });
    };

    return (
      <div className="lightGrayBorder" style={{ padding: "10px" }}>
        {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div className="headerTealText">
          {t("welcomeString.performanceData")}
        </div>

      </div> 
      <div className="descriptionText">
        {t("welcomeString.performanceDataDescription")}
      </div>*/}

        <div className="box-title flex-between-center" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>{t("ValueStrings.selectFileToUpload")}</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <PopoverText
              descriptor={<img src={InfoIconGreen} alt="icon" />}
              descriptionText={t("ValueStrings.fileExplorerDescription")}
            />
            <PopoverText
              descriptor={<img src={QuestionIcon} alt="question icon" />}
              descriptionText={t("ValueStrings.fileUploadTroubleshooting").split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              ))}
            />
          </div>
        </div>
        <input
          ref={inputRef}
          type="file"
          onChange={handleFileUpload}
          accept=".xlsx, .xls, .csv"
          style={{ display: "none" }}
        />

        <div className="note">{t("ValueStrings.uploadFileNote")} </div>

        <div style={{ display: "flex", alignItems: "center" }}>
          <DupontButton
            type="tertiary"
            onClick={handleAddFileClick}
            disabled={file || fileName}
            customClass="d-flex add-button "
          >
            {t("ValueStrings.addFile")}
            <span style={{ marginLeft: "10px", marginTop: "-1px" }}>
              <AddIcon fontSize="small" />
            </span>
          </DupontButton>
          {(file || fileId) && (
            <>
              <div className="selected-file">
                {file?.name || fileName}
                {isLoading || isFileLoading ? (
                  <CircularProgress
                    size="20px"
                    thickness={5}
                    className="close-icon"
                    style={{ position: "right", color: "teal" }}
                  />
                ) : (
                  <CloseIcon
                    onClick={handleCloseClick}
                    className="close-icon"
                  />
                )}
              </div>
              {(isLoading || isFileLoading) && (
                <div style={{ marginLeft: "20px" }}>
                  <b> {t("ValueStrings.fileUploadText")}</b>
                </div>
              )}
            </>
          )}
        </div>
        {error && <div className="errorMsg marginTop10">{error}</div>}
      </div>
    );
  }
);

export default PerformanceData;
